/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_LabelInputs */

const en_passkey_label = /** @type {(inputs: Passkey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name for the new passkey (optional)`)
};

const de_passkey_label = /** @type {(inputs: Passkey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name für den neuen Passkey (optional)`)
};

/**
* | output |
* | --- |
* | "Name for the new passkey (optional)" |
*
* @param {Passkey_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_label = /** @type {((inputs?: Passkey_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_label(inputs)
	return en_passkey_label(inputs)
});